import { Slide } from '@features/powerpoint';
import {
  inmarketLciLogo,
  titleSlideBackground,
  titleSlideGradient,
} from '../images';
import { headerTextStyles } from '../utils';
import { CampaignWithCalculatedFields } from '@components/Dashboard/hooks/useCampaign';

const SUBTITLE_FONT_SIZE = 12;
const FOOTER_FONT_SIZE = 8;

export const titleSlide = (
  campaign: Pick<CampaignWithCalculatedFields, 'id' | 'name'>
): Slide => ({
  images: [
    {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      path: titleSlideBackground,
    },
    {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      path: titleSlideGradient,
    },
    {
      x: 0.91,
      y: 2.13,
      w: 4.06,
      h: 0.94,
      path: inmarketLciLogo,
    },
  ],
  texts: [
    {
      text: [
        {
          text: 'Measurement Report',
          options: {
            fontSize: headerTextStyles.titleSlide.fontSize,
            color: headerTextStyles.titleSlide.color,
            bold: true,
            breakLine: true,
          },
        },
        {
          text: ' ',
          options: {
            fontSize: SUBTITLE_FONT_SIZE,
            color: headerTextStyles.titleSlide.color,
            breakLine: true,
          },
        },
        {
          text: `${campaign.name}\n${campaign.id}`,
          options: {
            fontSize: SUBTITLE_FONT_SIZE,
            color: headerTextStyles.titleSlide.color,
          },
        },
      ],
      options: {
        h: 0.98,
        w: 5.1,
        x: 0.76,
        y: 4.17,
      },
    },
    {
      text: 'Copyright © InMarket All rights reserved.',
      options: {
        fontSize: FOOTER_FONT_SIZE,
        color: headerTextStyles.titleSlide.color,
        h: 0.14,
        w: 5.54,
        x: 0.76,
        y: 7.06,
      },
    },
  ],
});
